import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { xcriticalFiltersChangeFilter, IStateFilter } from '@xcritical/filter';

import {
  OptimizedMenuList,
  DictionarySelect,
} from '@crm-framework/form-fields';
import { Label } from '@crm-framework/label';

import { StyledGrid } from './styled';
import { TIMEZONE_FIELD_NAME } from './consts';

export interface ITimeZoneSelectProps {
  dashboardName: string;
  timeZoneFilter?: IStateFilter;
}

export const TimeZoneSelect: React.FC<ITimeZoneSelectProps> = ({
  dashboardName,
  timeZoneFilter,
}) => {
  const dispatch = useDispatch();

  const onChangeTimeZone = useCallback(
    (_value) => {
      dispatch(
        xcriticalFiltersChangeFilter(dashboardName, {
          field: 'value',
          guid: timeZoneFilter!.key,
          value: _value,
        })
      );
    },
    [dashboardName]
  );

  return (
    <StyledGrid columns="auto 250px">
      <Label lineHeight="30px">Time Zone</Label>
      <DictionarySelect
        isSearchable
        shouldFitContainer
        closeMenuOnSelect
        value={timeZoneFilter?.value || 'UTC'}
        appearance="filters-value-select"
        placeholder="Search..."
        components={{ MenuList: OptimizedMenuList }}
        dictionaryName={TIMEZONE_FIELD_NAME}
        onChange={onChangeTimeZone}
        hideSelectedOptions={false}
      />
    </StyledGrid>
  );
};
